import { Builder } from '@builder.io/react'
import React, { useEffect } from 'react'

declare global {
  interface Window {
    Trustpilot: any
  }
}

interface Props {
  backgroundColor: string
  tags: string
}

const TrustPilotAlternate = ({ backgroundColor, tags }: Props) => {
  useEffect(() => {
    console.log('TrustPilotAlternate::Change', window, window.Trustpilot)
    const trustCarousel = document.getElementById('trust-pilot-carousel')
    window.Trustpilot?.loadFromElement(trustCarousel)
  }, [])

  return (
    // <!-- TrustBox widget - Alternate -->
    <div
      className="trustpilot-widget w-full p-4"
      data-locale="en-GB"
      data-template-id="54ad5defc6454f065c28af8b"
      data-businessunit-id="5af423d4a3303b0001bf47c1"
      data-style-height="200px"
      data-style-width="100%"
      data-theme="light"
      data-stars="5"
      data-review-languages="en"
      data-font-family="Montserrat"
      data-text-color="#004355"
      style={{ backgroundColor }}
      data-tags={tags ? tags : ''}
    >
      <a href="https://uk.trustpilot.com/review/differentdog.com" target="_blank" rel="noreferrer noopener"></a>
    </div>
    // <!-- End TrustBox widget -->
  )
}

export default TrustPilotAlternate

Builder.registerComponent(TrustPilotAlternate, {
  name: 'TrustPilotAlternate',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'tags',
      type: 'text',
      defaultValue: ''
    }
  ]
})
